import { Observable } from 'rxjs';
import type { AccountStatsResponse, AccountPlanDto } from '@coin-depo-types';

export interface AccountStatsFacadeBase {
  cachedAccountStats$: Observable<AccountStatsResponse>;
  cachedTotalInterestPaid$: Observable<number>;
  cachedTotalAccruedInterest$: Observable<number>;
  cachedTotalAvailableBalance$: Observable<number>;
  cachedTotalBalance$: Observable<number>;

  updateAccountStats(
    currency?: string,
    waiteUntil?: Observable<any>
  ): Observable<AccountStatsResponse | string | null>;

  getAccountStateSnapshot(): AccountStatsResponse;
  getAccountPlansSnapshot(): AccountPlanDto[];
}


export interface AccountStatsFacade extends AccountStatsFacadeBase {
  internalTransfer(
    from_account_id: number,
    to_account_id: number,
    amount: number,
    coin_id: number,
    comments?: string
  ): Observable<any>;

  createDepositPlan(
    plan_id: number,
    coin_id: number,
    amount: number
  ): Observable<any>;

  withdrawFundsRequest(
    account_id: number,
    amount: number,
    address: string,
    coin: string,
    request_id: string,
    tag: string,
    estimate?: boolean
  ): Observable<any>;

  withdrawFundsConfirmation(
    request_code: string,
    request_id: string,
    email_token: string,
    totp: string
  ): Observable<any>;

  resendWithdrawalCode(request_code: string): Observable<any>;

  setPayoutCurrency(
    account_id: number,
    interest_coin_id: number
  ): Observable<any>;

  setAccountVisibility(
    deposit_plan_id: number,
    visibility: boolean
  ): Observable<any>;

  getUserWallet(ticker: string): Observable<any>;

  getAccountPlanByIdSnapshot(
    coinId: string | number
  ): AccountPlanDto[] | undefined;
}